import * as React from 'react';

interface IProps {
    item: string;
    key: number;
}

const CommunicationRecieverListRow = (props: IProps) => {
    return (
        <tr>
            <td>{props.item}</td>
        </tr>
    );
};

export default CommunicationRecieverListRow;
